<template>
  <div>
    <!-- Modals -->
    <!-- Modal Promijeni status -->
    <modal
      v-if="order.status"
      id="modalPromijeniStatus"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <h5 slot="header">
        <strong>Promjena statusa</strong>
      </h5>

      <div slot="body">
        <div class="form-group row">
          <label class="col-lg-2 control-label text-lg-end pt-2">Status</label>
          <div class="col-lg-10">
            <select
              class="form-control populate form-control-modern"
              v-model="order.status"
            >
              <option
                :value="item.id"
                v-for="item in orderStatuses"
                :key="item.id"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.stop.prevent="updateOrderStatus"
            >
              Primjeni
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="add-article" cssClass="modal-md-2">
      <header slot="header">
        <h2 class="card-title">Dodavanje artikla</h2>
      </header>
      <section slot="body">
        <div class="card-body">
          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2">
              Pretraga
            </label>
            <div class="col-lg-10">
              <div class="header-center">
                <div class="header-search">
                  <div class="header-search-wrapper">
                    <input
                      type="search"
                      class="form-control"
                      placeholder="Unesite minimalno 3 karaktera"
                      v-model="searchInput"
                      @input="handleSearch"
                      @blur="handleBlur()"
                    />

                    <ul class="article-list bg-body" v-if="showSearchResults">
                      <li
                        v-for="article in articles"
                        :key="article.id"
                        @click="
                          articleId = article.id;
                          onArticleSelect('new', false);
                        "
                      >
                        <div class="article-wrapper">
                          <img
                            v-if="article.highlightedImageUrl"
                            :src="`${baseUrl}${article.highlightedImageUrl}`"
                            class="article-image"
                          />

                          <img
                            v-else
                            class="article-image"
                            :src="'img/products/product-8.jpg'"
                          />
                          <div class="article-description">
                            <div class="article-title">
                              {{ article.title }}
                            </div>
                            <div class="article-code">
                              {{ article.code }}
                            </div>
                            <div class="article-price">
                              {{ article.price | money2 }}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li
                        v-for="variation in variations"
                        :key="variation.id"
                        @click="
                          variationId = variation.id;
                          articleId = variation.articleId || (variation.article && variation.article.id);
                          onArticleSelect('new', true);
                        "
                      >
                        <div class="article-wrapper">
                          <img
                            v-if="variation.highlightedImage"
                            :src="`${baseUrl}${variation.highlightedImage}`"
                            class="article-image"
                          />

                          <img
                            v-else
                            class="article-image"
                            :src="'img/products/product-8.jpg'"
                          />
                          <div class="article-description">
                            <div class="article-title">
                              {{ variation.article.title }}
                            </div>
                            <div class="article-code">
                              {{ variation.code }}
                            </div>
                            <div
                              v-if="variation.description"
                              class="article-variation-description"
                            >
                              {{ variation.description }}
                            </div>
                            <div class="article-price">
                              {{ variation.vpc | money2 }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>

                    <button class="btn" type="button">
                      <i class="icon-magnifier"></i>
                    </button>
                  </div>
                  <!-- End .header-search-wrapper -->
                </div>
                <!-- End .header-search -->
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for="code"
              >Šifra</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="code"
                v-model="article.code"
                disabled
              />
            </div>
            <label
              class="col-lg-1 control-label text-lg-end pt-2"
              for="measure-unit"
              >JMJ</label
            >
            <div class="col-lg-4">
              <input
                type="text"
                class="form-control form-control-modern"
                id="measure-unit"
                v-model="article.unitOfMeasureTitle"
                disabled
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="article-title"
              >Artikal</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="article-title"
                disabled
                v-model="article.title"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="article-quantity"
              >Količina</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="article-quantity"
                v-model.number="article.quantity"
                @input="onNewQuantityChange"
                @blur="checkIsNull('article.quantity')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for="vpc"
              >VPC</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="vpc"
                v-model.number="article.vpc"
                @input="onNewVPCChange"
                :disabled="!canManagePrices"
                @blur="checkIsNull('article.vpc')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >Rabat %</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                id="article-discount1"
                class="form-control form-control-modern"
                v-model.number="article.discount1"
                @input="onNewDiscountChange"
                :disabled="!canManagePrices"
                @blur="checkIsNull('article.discount1')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2">
              VPC - Rabat
            </label>
            <div class="col-lg-5">
              <input
                type="text"
                id="article-amount"
                class="form-control form-control-modern"
                v-model.number="article.amount"
                @input="onNewAmountChange"
                :disabled="!canManagePrices"
                @blur="checkIsNull('article.amount')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >Porez 17%</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                :value="(article.taxAmount || 0).toFixed(2)"
                disabled
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="total-amount"
              >Iznos</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="total-amount"
                :value="(article.totalAmount || 0).toFixed(2)"
                disabled
              />
            </div>
          </div>
        </div>
      </section>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss mx-2"
              aria-label="Close"
              @click="closeModal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="addArticleToOrder"
            >
              Dodaj artikal
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!-- Modal Animation Promijeni iznose -->
    <modal
      id="modalPromijeniIznose"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <section class="card">
        <header class="card-header">
          <h2 class="card-title">Promijeni iznose</h2>
        </header>
        <div class="card-body">
          <div class="modal-wrapper">
            <div class="form-group row">
              <label class="col-lg-3 control-label text-lg-end pt-2" for=""
                >Narudžba (KM)</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 control-label text-lg-end pt-2" for=""
                >Dostava (KM)</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 control-label text-lg-end pt-2" for=""
                >Porez 17% (KM)</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-3 control-label text-lg-end pt-2" for=""
                >Total (KM)</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button class="btn btn-default modal-dismiss">Odustani</button>
              <button class="btn btn-primary modal-confirm">
                Dodaj artikl
              </button>
            </div>
          </div>
        </footer>
      </section>
    </modal>

    <!-- Modal Podaci za naplatu -->
    <modal
      id="modalPodaciZaNaplatu"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <section class="card">
        <header class="card-header">
          <h2 class="card-title">Podaci za naplatu/dostavu</h2>
        </header>
        <div class="card-body">
          <div class="modal-wrapper">
            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Ime i prezime</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Email</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Telefon</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Kompanija</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Adresa</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Adresa 2</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2"
                >Grad</label
              >
              <div class="col-lg-10">
                <select
                  data-plugin-selectTwo
                  class="form-control populate form-control-modern"
                  data-plugin-options='{
                    "minimumInputLength": 2
                  }'
                >
                  <option value="00">Traži</option>
                  <option value="CA">Grad 1</option>
                  <option value="NV">Grad 2</option>
                  <option value="OR">Grad 3</option>
                  <option value="WA">Grad 4</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Pošt. br.</label
              >
              <div class="col-lg-10">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2"
                >Zemlja</label
              >
              <div class="col-lg-10">
                <select
                  data-plugin-selectTwo
                  class="form-control populate form-control-modern"
                  data-plugin-options='{
                    "minimumInputLength": 2
                  }'
                >
                  <option value="00">Traži</option>
                  <option value="CA">Zemlja 1</option>
                  <option value="NV">Zemlja 2</option>
                  <option value="OR">Zemlja 3</option>
                  <option value="WA">Zemlja 4</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button class="btn btn-default modal-dismiss">Odustani</button>
              <button class="btn btn-primary modal-confirm">Spremi</button>
            </div>
          </div>
        </footer>
      </section>
    </modal>

    <!-- Modal Promijeni vrstu dostave -->
    <modal
      id="modalPromijeniDostavu"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <header slot="header">
        <h2 class="card-title">Vrsta dostave</h2>
      </header>
      <div slot="body">
        <div class="form-group row">
          <label class="col-lg-3 control-label text-lg-end pt-2">
            Dostava
          </label>
          <div class="col-lg-9">
            <select
              class="form-control populate form-control-modern"
              v-model="order.deliveryType"
            >
              <option v-for="item in deliveryTypes" :key="item" :value="item">
                {{ deliveryTypeTranslations[item] }}
              </option>
            </select>
          </div>
        </div>

        <div
          class="form-group row"
          v-if="order.deliveryType === deliveryTypes.EXPRESS_POST"
        >
          <label class="col-lg-3 control-label text-lg-end pt-2">
            Brza pošta
          </label>
          <div class="col-lg-9">
            <select
              class="form-control populate form-control-modern"
              v-model="order.expressPostId"
            >
              <option :value="null">Izaberite brzu poštu</option>
              <option
                v-for="item in expressPosts"
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss mx-2"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="updateDeliveryType"
            >
              Promijeni
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!-- Modal Animation Uredi artikal -->
    <modal
      id="modalAnim"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <section class="card">
        <header class="card-header">
          <h2 class="card-title">Dodavanje artikla</h2>
        </header>
        <div class="card-body">
          <div class="modal-wrapper">
            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2"
                >Artikal</label
              >
              <div class="col-lg-10">
                <select
                  data-plugin-selectTwo
                  class="form-control populate form-control-modern"
                  data-plugin-options='{
                    "minimumInputLength": 2
                  }'
                >
                  <option value="00">Traži</option>
                  <option value="CA">California</option>
                  <option value="NV">Nevada</option>
                  <option value="OR">Oregon</option>
                  <option value="WA">Washington</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Šifra</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
              <label class="col-lg-1 control-label text-lg-end pt-2" for=""
                >JMJ</label
              >
              <div class="col-lg-4">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >VPC</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Rabat</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >VPC - Rabat</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                  readonly
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Porez 17%</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-lg-2 control-label text-lg-end pt-2" for=""
                >Iznos</label
              >
              <div class="col-lg-5">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  id=""
                />
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button class="btn btn-default modal-dismiss">Odustani</button>
              <button class="btn btn-primary modal-confirm">
                Dodaj artikl
              </button>
            </div>
          </div>
        </footer>
      </section>
    </modal>

    <!-- Modal Animation uredi stanje narudžbe - note -->
    <modal
      id="modalStanjeNarudzbe"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <h2 class="card-title" slot="header">Dodavanje stanja narudžbe</h2>
      <div slot="body">
        <div class="form-group row">
          <label class="col-lg-3 control-label text-lg-end pt-2">
            Stanje
          </label>
          <div class="col-lg-9">
            <input
              type="text"
              class="form-control form-control-modern"
              v-model="orderState.state"
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-3 control-label text-lg-end">
            Prikaži klijentu
          </label>
          <div class="col-lg-5">
            <input
              type="checkbox"
              id="show-to-client"
              class="checkbox-style-1"
              v-model="orderState.displayToCustomer"
            />
          </div>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss mr-2"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click.stop.prevent="addOrderState"
            >
              Dodaj stanje
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!--Are you sure? Otkaži narudžbu-->
    <modal
      id="modalOtkaziNarudzbu"
      class="zoom-anim-dialog modal-block modal-block-danger mfp-hide"
    >
      <h5 slot="header" class="card-title">Upozorenje?</h5>
      <div slot="body">
        <div class="modal-icon">
          <i class="fas fa-question-circle"></i>
        </div>
        <div class="modal-text">
          <h4 class="font-weight-bold text-dark">Pažnja!</h4>
          <p>Jeste li sigurni da želite otkazati narudžbu?</p>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss mr-2"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
            <button
              class="btn btn-danger modal-confirm"
              @click.stop.prevent="cancelOrder"
            >
              Otkaži narudžbu
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!--Are you sure? Povrat svih sredstava-->
    <modal
      id="modalRefundAll"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <section class="card">
        <header class="card-header">
          <h2 class="card-title">Upozorenje?</h2>
        </header>
        <div class="card-body">
          <div class="modal-wrapper">
            <div class="modal-icon">
              <i class="fas fa-question-circle"></i>
            </div>
            <div class="modal-text">
              <h4 class="font-weight-bold text-dark">Pažnja!</h4>
              <p>Jeste li sigurni da želite izvršiti povrat sredstava?</p>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button class="btn btn-default modal-dismiss">Odustani</button>
              <button class="btn btn-primary modal-confirm">
                Izvrši povrat
              </button>
            </div>
          </div>
        </footer>
      </section>
    </modal>

    <!--Are you sure? Povrat djelomičnih sredstava-->
    <modal
      id="modalRefundPartial"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <section class="card">
        <header class="card-header">
          <h2 class="card-title">Upozorenje?</h2>
        </header>
        <div class="card-body">
          <div class="modal-wrapper">
            <div class="modal-icon">
              <i class="fas fa-question-circle"></i>
            </div>
            <div class="modal-text">
              <h4 class="font-weight-bold text-dark">Pažnja!</h4>
              <p>Odredite iznos koji želite vratiti</p>
            </div>
            <div class="form-group row">
              <label
                class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 pt-3"
                >Povrat (KM)</label
              >
              <div class="col-lg-7 col-xl-8">
                <input
                  type="number"
                  class="form-control form-control-modern"
                  name=""
                  value=""
                />
                <p>Maksimalni iznos povrata je 50 KM</p>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button class="btn btn-default modal-dismiss">Odustani</button>
              <button class="btn btn-primary modal-confirm">Ukloni</button>
            </div>
          </div>
        </footer>
      </section>
    </modal>

    <!--Are you sure?-->
    <modal
      id="delete-order-state-modal"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <h2 class="card-title" slot="header">Upozorenje?</h2>
      <div slot="body">
        <div class="modal-icon">
          <i class="fas fa-question-circle"></i>
        </div>
        <div class="modal-text">
          <h4 class="font-weight-bold text-dark">Pažnja!</h4>
          <p>Jeste li sigurni da želite ukloniti odabrane stavke?</p>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end d-flex justify-content-end">
            <button
              class="btn btn-default modal-dismiss mx-1"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="deleteOrderState()"
            >
              Ukloni
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <modal
      id="delete-order-item-modal"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <h2 class="card-title" slot="header">Upozorenje?</h2>
      <div slot="body">
        <div class="modal-icon">
          <i class="fas fa-question-circle"></i>
        </div>
        <div class="modal-text">
          <h4 class="font-weight-bold text-dark">Pažnja!</h4>
          <p>Jeste li sigurni da želite ukloniti odabrane stavke?</p>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end d-flex justify-content-end">
            <button
              class="btn btn-default modal-dismiss mx-1"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="deleteOrderItem()"
            >
              Ukloni
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <modal
      id="update-order-item-quantity-modal"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
    >
      <h2 class="card-title" slot="header">Upozorenje?</h2>
      <div slot="body">
        <div class="modal-icon">
          <i class="fas fa-question-circle"></i>
        </div>
        <div class="modal-text">
          <h4 class="font-weight-bold text-dark">Pažnja!</h4>
          <p>Jeste li sigurni da želite izmjeniti količinu?</p>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end d-flex justify-content-end">
            <button
              class="btn btn-default modal-dismiss mx-1"
              data-bs-dismiss="modal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="saveOrderItemQuantity()"
            >
              Sačuvaj
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!-- End Modals -->

    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-info-circle"></i>
                <h2 class="card-big-info-title">Info</h2>
                <p class="card-big-info-desc">Glavne informacije o narudžbi.</p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Komitent</label
                  >
                  <div class="col-lg-4 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="(order.user || {}).company"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Broj narudžbe</label
                  >
                  <div class="col-lg-4 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="order.id"
                      readonly
                    />
                  </div>
                </div>

                <div v-if="order.parentOrderId" class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Broj originalne narudžbe</label
                  >
                  <div class="col-lg-4 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="order.parentOrderId"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >B2B/B2C</label
                  >
                  <div class="col-lg-4 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="order.b2B ? 'B2B' : 'B2C'"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    ERP sinkronizirano?
                  </label>
                  <div class="col-lg-4 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="order.isErpSynchronized ? 'Da' : 'Ne'"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Datum kreiranja narudžbe</label
                  >
                  <div class="col-lg-4 col-xl-3">
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :value="formatMomentDate(order.createdDate)"
                        readonly
                      />
                      <!--<input type="text" data-plugin-datepicker class="form-control form-control-modern">-->
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Korisnik</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      v-if="order && order.user"
                      type="text"
                      class="form-control form-control-modern"
                      :value="`${order.user.firstName} ${order.user.lastName}`"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >E-mail kupca</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      v-if="order && order.user"
                      type="text"
                      class="form-control form-control-modern"
                      :value="order.user.email"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center" v-if="order.mergedOrders">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Spojene narudžbe</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <span
                      v-for="mergedOrder in order.mergedOrders"
                      :key="mergedOrder"
                      class="mr-2"
                    >
                      {{ mergedOrder }}
                    </span>
                  </div>
                </div>

                <div class="form-group row align-items-center" v-if="!order.b2B">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">
                      {{ translations.forms.labels.company }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="order.companyId"
                      >
                        <option :value="null">
                          Izaberite kompaniju
                        </option>
                        <option
                          :value="item.id"
                          :key="item.id"
                          v-for="item in masterCompanies"
                        >
                          {{ item.title }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="col-lg-2"
                      style="margin-left: 18px"
                    >
                      <button
                        class="btn btn-primary"
                        @click="saveOrderCompany"
                      >
                        Spremi kompaniju
                      </button>
                    </div>
                  </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Status narudžbe</label
                  >
                  <div class="col-lg-3 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern font-weight-bold"
                      :value="mapOrderStatus(order.status)"
                      required
                      readonly
                    />
                  </div>

                  <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                    <button
                      class="btn btn-warning btn-sm font-weight-semibold btn-py-2 modal-with-zoom-anim mr-2"
                      data-bs-toggle="modal"
                      data-bs-target="#modalOtkaziNarudzbu"
                    >
                      Otkaži narudžbu
                    </button>

                    <button
                      class="btn btn-primary btn-sm font-weight-semibold btn-py-2 modal-with-zoom-anim mr-2"
                      data-bs-toggle="modal"
                      data-bs-target="#modalPromijeniStatus"
                    >
                      Promijeni status
                    </button>

                    <button
                      v-if="backendOrderStatus === 1"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#delete-order-modal"
                      class="delete-button btn btn-danger btn-sm font-weight-semibold btn-py-2 modal-with-zoom-anim"
                    >
                      Izbriši narudžbu
                    </button>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Exportirano za brzu poštu</label
                  >
                  <div class="col-lg-3 col-xl-3">
                    <input
                      type="text"
                      class="form-control form-control-modern font-weight-bold"
                      :value="order.isExportedCSVForExpressPost ? 'Da' : 'Ne'"
                      required
                      readonly
                    />
                  </div>

                  <div class="col-12 col-lg-6 mb-3 mb-lg-0 ">
                    <div class="col-4" style="padding-right: 16px;">
                      <button
                        class="btn btn-warning btn-sm font-weight-semibold col-9 pr-2 btn-py-2 modal-with-zoom-anim"
                        data-bs-toggle="modal"
                        data-bs-target="#export-order-modal"
                      >
                        Exportiraj
                      </button>
                    </div>
                  </div>
                </div>

                <hr />

                <!-- <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Narudžba (KM)</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="order.totalAmount"
                      readonly
                    />
                  </div>
                </div> -->

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Ukupno bez poreza</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="((order.totalWithoutVat || 0)).toFixed(2)"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Porez</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="(order.totalVat || 0).toFixed(2)"
                      readonly
                    />
                  </div>
                </div>

                <div v-if="order.promoCode" class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Promo kod</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="-(order.discountCodeAmount || 0).toFixed(2)"
                      readonly
                    />
                  </div>
                </div>

                <div v-if="order.giftCard" class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Poklon kod</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="-(order.discountCodeAmount || 0).toFixed(2)"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Ukupno</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="(order.totalAmount || 0).toFixed(2)"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Dostava</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="(order.transportPrice || 0).toFixed(2)"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Ukupno s dostavom</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      :value="
                        (
                          order.totalAmount + (order.transportPrice || 0)
                        ).toFixed(2)
                      "
                      readonly
                    />
                  </div>
                </div>

                <!-- <div class="form-group row align-items-center">
                  <div class="col-lg-5 col-xl-3"></div>
                  <div class="col-lg-7 col-xl-8">
                    <a
                      href="#modalPromijeniIznose"
                      class="
                        btn btn-primary btn-sm
                        font-weight-semibold
                        btn-py-2
                        modal-with-zoom-anim
                      "
                      >Promijeni iznose</a
                    >
                  </div>
                </div> -->

                <hr />

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Način plaćanja</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      name=""
                      :value="paymentTypes[order.paymentType] || '-'"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Status plaćanja
                  </label>
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      value="-"
                      readonly
                    />
                  </div>
                </div>

                <hr />
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Napomena
                  </label>
                  <div class="col-lg-7 col-xl-8">
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="order.note"
                      :readonly="!loggedUser.isWebShopAdministrator"
                    ></textarea>
                  </div>
                </div>

                <div class="col-12 row">
                  <div
                    class="col-lg-12 col-md-12 col-sm-12"
                    style="text-align: right; margin-top: 20px"
                  >
                    <button
                      class="btn btn-primary"
                      @click="saveOrderDescription"
                      :disabled="!loggedUser.isWebShopAdministrator"
                    >
                      Spremi napomenu
                    </button>
                  </div>
                </div>

                <!-- <div class="form-group row align-items-center">
                  <div class="col-lg-5 col-xl-3"></div>
                  <div class="col-lg-3 col-xl-8">
                    <a
                      href="#modalRefundAll"
                      class="
                        btn btn-primary btn-sm
                        font-weight-semibold
                        btn-py-2
                        modal-with-zoom-anim
                        mr-2
                      "
                      >Povrat sredstava</a
                    >
                    <a
                      href="#modalRefundPartial"
                      class="
                        btn btn-primary btn-sm
                        font-weight-semibold
                        btn-py-2
                        modal-with-zoom-anim
                      "
                      >Djelomični povrat</a
                    >
                  </div>
                </div> -->

                <!--<div class="form-group row">
                                <label class="col-lg-5 col-xl-3 control-label text-lg-end pt-2 mt-1 mb-0">Product Description</label>
                                <div class="col-lg-7 col-xl-8">
                                    <textarea class="form-control form-control-modern" name="productDescription" rows="6"></textarea>
                                </div>
                            </div>-->

                <!-- <hr />

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Vaša trgovina</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      name=""
                      value="Naziv trgovine"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Guid narudžbe</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      name=""
                      value="03e45rh25j21654645345gdfg5"
                      readonly
                    />
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >IP adresa kupca</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      name=""
                      value="127.0.0.1"
                      readonly
                    />
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <div class="card card-modern card-modern-table-over-header">
          <div class="card-header">
            <div class="w-100 d-flex justify-content-between">
              <div class="title-icon">
                <i class="fas fa-shopping-cart"></i>
                <h2 class="card-title">Proizvodi / Artikli</h2>
              </div>
              <div class="col-1">
                <h2 v-if="order.b2B" class="card-title px-1">B2B</h2>
                <h2 v-else class="card-title px-1">B2C</h2>
              </div>
            </div>
            <div class="row align-items-center mb-1 mt-3">
              <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                <a
                  href="#add-article"
                  data-bs-toggle="modal"
                  data-bs-target="#add-article"
                  class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                >
                  + Dodaj stavku
                </a>
                <button
                  class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                  type="button"
                  @click.prevent.stop="showConfirmationModal"
                >
                  - Ukloni stavku
                </button>
              </div>
              <div class="col-lg d-flex justify-content-end align-items-center">
                <button
                  class="btn btn-default btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim d-flex align-items-center"
                  @click="printOrder"
                >
                  <i class="bx bx-printer text-5 me-2"></i>
                  Print narudžbe
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div>
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-borderless table-striped mb-0"
                  style="min-width: 640px"
                >
                  <thead>
                    <tr>
                      <th width="30">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th>RBR</th>
                      <th>Šifra</th>
                      <th>Naziv</th>
                      <th>Atributi</th>
                      <th v-for="(state, index) in order.warehouseTowns" :key="index">
                        {{ state }}
                      </th>
                      <th>Količina</th>
                      <th>Cijena</th>
                      <th>Rabat</th>
                      <th>Vrijednost</th>
                      <th>Porez</th>
                      <th>Iznos</th>
                      <!-- <th>Akcije</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(item, index) in order.orderItems"
                      :key="item.id"
                    >
                      <td
                        width="30"
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="item.id"
                          v-model="selected"
                        />
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        {{ index + 1 }}
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        <strong>{{ item.articleCode }}</strong>
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        <strong>{{ item.article }}</strong>
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                         <div v-for="(variation, index) in item.orderItemVariation" :key="index">
                          <strong>{{ variation.attributeTitle }}:</strong> 
                          <p v-if="variation.attributeStyle === 1"
                            :style="{ 
                              borderRadius: '50%',
                              width: '32px',
                              height: '32px',
                              backgroundColor: variation.attributeValue,
                              color: variation.attributeValue,
                            }"
                            >
                          </p>
                          <p v-else>{{ variation.attributeValue }}</p>
                        </div>
                      </td>
                      <!-- <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0 }"
                      >
                        <strong>{{
                          item.articleStockAmount.toFixed(2).replace('.', ',')
                        }}</strong>
                      </td> -->
                      <td
                        v-for="(amount, index) in item.articleStockAmounts"
                        :key="index"
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        <strong :style="amount.articleExists === false ? { color: 'red' } : {}">{{ amount.articleExists === false ? 'N/A' : amount.stockAmount.toFixed(2).replace('.', ',') }}</strong>
                      </td>
                      <td
                        style="max-width: 90px;"
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        <div class="d-flex">
                          <input
                            type="number"
                            class="form-control"
                            v-model.number="item.quantity"
                          />
                          <!-- <button
                            :disabled="item.quantity === item.originalQuantity"
                            class="mx-2 btn btn-primary"
                            :class="{
                              disabled: item.quantity === item.originalQuantity,
                            }"
                            @click="
                              showUpdateQuantityModal(item.id, item.quantity)
                            "
                          >
                            Sačuvaj
                          </button> -->
                        </div>
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        {{ (order.b2B? item.articleVPC : item.articleMPC) | money2 }}
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        {{
                          item.discount.toFixed(2)
                            .replace('.', ',')
                        }}
                        %
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        {{ item.totalAmount - item.totalVat | money2 }}
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        {{ item.totalVat | money2 }}
                      </td>
                      <td
                        :class="{ 'stock-amount': item.articleStockAmount === 0,
                          'overstock-amount': item.articleStockAmount > 0 && item.quantity > item.articleStockAmount
                         }"
                      >
                        {{ item.totalAmount | money2 }}
                      </td>
                      <!-- <td>
                        <div class="table-item-edit-delete">
                        
                          <button
                            class="btn btn-default btn-sm font-weight-semibold btn-py-1 modal-with-zoom-anim"
                            @click="showDeleteOrderItemModal(item.id)"
                          >
                            <i class="fas fa-trash-alt" /> Ukloni
                          </button>
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr class="solid opacity-4" />
              <div class="col-12 row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="datatable-footer">
                    <div
                      class="row align-items-center justify-content-between mt-3"
                    >
                      <div class="col-md-auto order-1 mb-3 mb-lg-0">
                        <!-- <div class="d-flex align-items-stretch">
                          <div
                            class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                          >
                            <select
                              class="form-control select-style-1 bulk-action"
                              name="bulk-action"
                              v-model="bulkAction"
                              style="min-width: 170px"
                            >
                              <option value="" selected="">Bulk Actions</option>
                              <option value="delete">Delete</option>
                            </select>

                            <button
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-modal"
                              class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                            >
                              {{ translations.apply }}
                            </button>
                          </div>
                        </div> -->
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                          <a
                            href="#add-article"
                            data-bs-toggle="modal"
                            data-bs-target="#add-article"
                            class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                          >
                            + Dodaj stavku
                          </a>
                          <button
                            class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                            type="button"
                            @click.prevent.stop="showConfirmationModal"
                          >
                            - Ukloni stavku
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-12"
                  style="text-align: right; margin-top: 20px"
                >
                  <button
                    class="btn btn-default modal-with-zoom-anim"
                    style="margin-right: 5px"
                    @click="splitOpenModal"
                  >
                    Izdvoji
                  </button>

                  <button
                    class="btn btn-warning"
                    style="margin-right: 5px"
                    @click="refreshStockAmount"
                  >
                    Osvježi stanje
                  </button>
                  <button
                    class="btn btn-primary"
                    @click="saveOrderItemsQuantity"
                  >
                    Spremi količine
                  </button>
                </div>
              </div>
              <!-- <a
                href="#modalAnim"
                class="btn btn-primary btn-sm font-weight-semibold btn-py-2 btn-px-4 modal-with-zoom-anim"
                >+ Dodaj artikal</a
              > -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <section class="card card-modern">
          <div class="card-header">
            <div class="title-icon">
              <i class="fas fa-map-marked-alt"></i>
              <h2 class="card-title">Naplata i dostava</h2>
            </div>
          </div>
          <div class="card-body" v-if="order && order.user">
            <div class="row">
              <div class="col-lg-6">
                <table
                  class="table table-responsive-md table-bordered mb-3 billing-shipping"
                >
                  <thead>
                    <tr>
                      <th colspan="2">Podaci za naplatu</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Kompanija</td>
                      <td>
                        {{ order.company?.title || 'N/A' }}
                      </td>
                    </tr>
                    <tr>
                      <td>Ime i prezime</td>
                      <td>
                        {{ order.user.firstName || 'N/A' }}
                        {{ order.user.lastName || 'N/A' }}
                      </td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{{ order.user.email || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td>Telefon</td>
                      <td>{{ orderPaymentsData.phone }}</td>
                    </tr>
                    <tr>
                      <td>Adresa</td>
                      <td>{{ orderPaymentsData.address }}</td>
                    </tr>
                    <tr>
                      <td>Grad</td>
                      <td>{{ orderPaymentsData.town }}</td>
                    </tr>
                    <tr>
                      <td>Pošt. br.</td>
                      <td>{{ orderPaymentsData.zipCode || 'N/A' }}</td>
                    </tr>
                    <tr>
                      <td>Zemlja</td>
                      <td>{{ orderPaymentsData.country }}</td>
                    </tr>
                  </tbody>
                </table>
                <a
                  href="#modalPodaciZaNaplatu"
                  class="btn btn-primary btn-sm font-weight-semibold btn-py-2 btn-px-4 modal-with-zoom-anim"
                  >Izmijeni</a
                >
              </div>
              <div class="col-lg-6">
                <table
                  class="table table-responsive-md table-bordered mb-3 billing-shipping"
                >
                  <thead>
                    <tr>
                      <th colspan="2">Podaci za dostavu</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Kompanija</td>
                      <td>
                        {{ order.shippingAddress.company }}
                      </td>
                    </tr>
                    <tr>
                      <td>Ime i prezime</td>
                      <td>
                        {{ order.user.firstName }}
                        {{ order.user.lastName }}
                      </td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{{ order.user.email }}</td>
                    </tr>
                    <tr>
                      <td>Telefon</td>
                      <td>{{ order.shippingAddress.phoneNumber }}</td>
                    </tr>
                    <tr>
                      <td>Adresa 1</td>
                      <td>{{ order.shippingAddress.address }}</td>
                    </tr>
                    <tr>
                      <td>Grad</td>
                      <td>{{ order.shippingAddress.town }}</td>
                    </tr>
                    <tr>
                      <td>Pošt. br.</td>
                      <td>{{ order.shippingAddress.zipCode }}</td>
                    </tr>
                    <tr>
                      <td>Zemlja</td>
                      <td>{{ order.shippingAddress.country }}</td>
                    </tr>
                  </tbody>
                </table>
                <a
                  href="#modalPodaciZaNaplatu"
                  class="btn btn-primary btn-sm font-weight-semibold btn-py-2 btn-px-4 modal-with-zoom-anim"
                  >Izmijeni</a
                >
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row no-border">
      <div class="col">
        <section class="card card-modern">
          <div class="card-body">
            <div class="form-group row align-items-center">
              <label class="col-lg-5 col-xl-2 control-label mb-0"
                >Vrsta dostave</label
              >
              <div class="col-lg-3 col-xl-4">
                <input
                  type="text"
                  class="form-control form-control-modern"
                  name=""
                  :value="deliveryTypeTranslations[order.deliveryType]"
                  readonly
                />
              </div>
              <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                <button
                  class="btn btn-primary btn-sm font-weight-semibold btn-py-2 btn-px-3 modal-with-zoom-anim"
                  data-bs-toggle="modal"
                  data-bs-target="#modalPromijeniDostavu"
                >
                  Promijeni
                </button>
                <button
                  class="btn btn-sm mx-2 btn-primary font-weight-semibold btn-py-2 btn-px-3"
                  v-if="deliveryTypes.EXPRESS_POST === order.deliveryType"
                  @click="sendToExpressPost"
                >
                  Pošalji brzoj pošti
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <div class="card card-modern card-modern-table-over-header">
          <div class="card-header">
            <div class="row">
              <div class="title-icon">
                <i class="fas fa-tasks"></i>
                <h2 class="card-title">Stanje narudžbe</h2>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div>
              <table
                class="table table-ecommerce-simple table-borderless table-striped mb-0"
                style="min-width: 640px"
              >
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Stanje</th>
                    <th>Prikaži klijentu</th>
                    <th>Izmjeni</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in orderStates" :key="item.id">
                    <td>{{ formatMomentDate(item.date) }}</td>
                    <td>{{ item.state }}</td>
                    <td>
                      <i
                        class="fas"
                        :class="{
                          'fa-check text-success': item.displayToCustomer,
                          'fa-times text-danger': !item.displayToCustomer,
                        }"
                      />
                    </td>
                    <td>
                      <div class="table-item-edit-delete">
                        <a
                          href="#modalStanjeNarudzbe"
                          class="btn btn-primary btn-sm font-weight-semibold btn-py-1 modal-with-zoom-anim mr-2"
                          ><i class="far fa-edit"></i> Uredi</a
                        >
                        <button
                          class="btn btn-default btn-sm font-weight-semibold btn-py-1 modal-with-zoom-anim"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-order-state-modal"
                          @click="selectedState = item.id"
                        >
                          <i class="fas fa-trash-alt" /> Ukloni
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr class="solid opacity-4" />
              <button
                class="btn btn-primary btn-sm font-weight-semibold btn-py-2 btn-px-4 modal-with-zoom-anim"
                data-bs-toggle="modal"
                data-bs-target="#modalStanjeNarudzbe"
              >
                + Dodaj stanje
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="deleteSelected()"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="delete-order-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="deleteOrder"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      id="split-modal"
      class="zoom-anim-dialog modal-block modal-block-primary mfp-hide"
      cssStyle="width: 1000px"
    >
      <header slot="header">
        <h2 class="card-title">{{ translations.splitOrders }}</h2>
      </header>
      <div slot="body">
        <div class="modal-wrapper">
          <div>
            <table
              class="table table-ecommerce-simple table-borderless table-striped mb-0"
              style="min-width: 640px"
            >
              <thead>
                <tr>
                  <th>RBR</th>
                  <th>Šifra</th>
                  <th>Naziv</th>
                  <th>Stanje</th>
                  <th>Naručeno</th>
                  <th width="100">Izdvoji</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  role="row"
                  v-for="(item, index) in order.orderItems"
                  :key="item.id"
                >
                  <td class="">{{ index + 1 }}</td>
                  <td class="">
                    <strong>{{ item.articleCode }}</strong>
                  </td>
                  <td class="">
                    <strong>{{ item.article }}</strong>
                  </td>
                  <td class="">
                    <strong>{{
                      item.articleStockAmount.toString().replace('.', ',')
                    }}</strong>
                  </td>
                  <td class="ordered">
                    <strong>{{
                      item.quantity.toString().replace('.', ',')
                    }}</strong>
                  </td>
                  <td width="100" class="">
                    <div class="d-flex">
                      <input
                        type="number"
                        class="form-control"
                        v-model="item.newQuantity"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss"
              style="margin-right: 5px"
              @click="cancelSplittingOrder"
            >
              Otkaži
            </button>
            <button class="btn btn-primary modal-confirm" @click="splitOrder">
              Izdvoji
            </button>
          </div>
        </div>
      </footer>
    </modal>
    <modal id="confirm-delete">
      <h5 slot="header">
        <strong>Ukloni odabrane artikle</strong>
      </h5>
      <div slot="body">
        Jeste li sigurni da želite ukloniti odabrane artikle?
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              data-bs-dismiss="modal"
              @click.prevent.stop="deleteSelected"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal id="export-order-modal">
      <h5 slot="header">
        <strong>{{ translations.exportCSV }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalTextExport"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="exportOrder"
            >
              Export
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { translations, pager } from '@/mixins';
import config from '@/config';
import moment from 'moment';
import api from '@/services/api';
import helpers from '@/services/helpers';
import Modal from '@/components/shared/modal/Modal.vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { debounce } from 'lodash';
import { format } from 'date-fns';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';

export default {
  name: 'EditOrder',
  components: {
    Modal,
  },
  mixins: [translations, pager],
  data() {
    return {
      deleteActionName: 'deleteOrderItems',
      orderState: {
        state: '',
        displayToCustomer: true,
      },
      selectedState: null,
      selectedItem: null,
      selected: [],
      searchInput: '',
      showSearchResults: false,
      articleId: null,
      variationId: null,
      backendOrderStatus: null,
    };
  },
  computed: {
    ransomReturnOptions() {
      return [
        { id: 0, label: 'Nema' },
        { id: 2, label: 'Ugovoreni korisnik(Treća strana)' },
      ];
    },
    modalTextExport() {
      return this.translations.areYouSureExportCSV;
    },
    articles() {
      let articles = this.$store.getters.getArticles;
      articles.forEach((item) => {
        if (item.price && item.price < item.vpc) {
          item.quantity = item.quantity || 1;
          item.discount = item.discount || 100 * (1 - item.price / item.vpc);
          item.amount = item.price;
        }
      });
      return articles;
    },
    variations() {
      let variations = this.$store.getters.getSearchVariations;
      
      variations = variations.map((item) => ({
        ...item,
        quantity: item.quantity || 1,
        discount: item.discount || 0,
        amount: item.vpc || 0,
      }))

      console.log(variations);

      return variations;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    bs() {
      return bs;
    },
    selectAll: {
      get: function () {
        // List must be defined in upper component
        return this.selected.length === (this.order.orderItems ?? []).length;
      },
      set: function (value) {
        const selected = [];

        if (value) {
          this.order.orderItems.forEach(function ({ id }) {
            selected.push(id);
          });
        }

        this.selected = selected;
      },
    },
    order() {
      var obj = this.$store.getters.getOrder;
      if (obj && obj.orderItems) {
        obj.orderItems.forEach((item) => {
          item.newQuantity = 0;
        });
      }
      return obj;
    },
    canManagePrices() {
      return (this.$store.getters.getLoggedUser.permissions ?? []).includes(
        'Manage Prices On Order Item'
      );
    },
    orderPaymentsData() {
      return this.order?.company || this.order.user;
    },
    orderStates() {
      return this.$store.getters.getOrderStates;
    },
    baseUrl() {
      return config.baseUrl;
    },
    units() {
      return this.$store.getters.getMeasurementUnits;
    },
    orderStatuses() {
      switch(this.backendOrderStatus) {
        // Prednarudzba, Otkazano - spojeno, Otkazano - razdvojeno
        case -1: return helpers.orderStatuses.filter(({ id }) => id === -1 || id === 1);
        case 6: return helpers.orderStatuses.filter(({ id }) => id === 6);
        case 7: return helpers.orderStatuses.filter(({ id }) => id === 7);

        // Zavrseno, Zavrseno (Isporuceno)
        case 4: return helpers.orderStatuses.filter(({ id }) => id === 3 || id === 4);
        case 5: return helpers.orderStatuses.filter(({ id }) => id === 3 || id === 5);

        // Kreirano
        case 1: return helpers.orderStatuses.filter(({ id }) => id === 1 || id === 2 || id === 3 || id === 8);

        // Neisporuceno
        case 8: return helpers.orderStatuses.filter(({ id }) => id === 8 || id === 5 || id === 3);

        // Odobreno
        case 2: return helpers.orderStatuses.filter(({ id }) => id === 2 || id === 3 || id === 4 || id === 5 || id === 8);

        // Otkazano
        case 3: return helpers.orderStatuses.filter(({ id }) => id === 1 || id === 2 || id === 3 || id === 8);

        default: return helpers.orderStatuses;
      }
    },
    deliveryTypes() {
      return helpers.deliveryTypes;
    },
    deliveryTypeTranslations() {
      return helpers.deliveryTypeTranslations;
    },
    expressPosts() {
      return this.$store.getters.getExpressPosts;
    },
    paymentTypes() {
      return helpers.PaymentTypeTranslations;
    },
     loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    article() {
  if (!this.articleId) return {};

  const article =
    this.articles.find(({ id }) => id === this.articleId) ||
    this.variation.article;

  if (!article) return {};

  this.$set(article, 'id', article.id || this.articleId);
  this.$set(article, 'quantity', article.quantity || 1);
  this.$set(article, 'discount1', article.discount1 || 0);
  this.$set(article, 'amount', article.amount || 0);       // <--
  this.$set(article, 'taxAmount', article.taxAmount || 0); // <--
  this.$set(article, 'totalAmount', article.totalAmount || 0);
  
  const unit = this.units.find(({ id }) => id === article.unitOfMeasureId);
  this.$set(article, 'unitOfMeasureTitle', article.unitOfMeasureTitle || (unit ? unit.title : ''));

  return article;
},
    variation() {
      if (!this.variationId) return {};

      const variation = this.variations.find(({ id }) => id === this.variationId);

      if (!variation) return {};

      this.$set(variation, 'totalAmount', variation.vpc || 0);

      return variation;
    },
    masterCompanies() {
      return this.$store.getters.getMasterCompanies;
    },
  },
  methods: {
    formatDate(date, dateFormat = 'dd.MM.yyyy, HH:mm') {
      return format(new Date(date), dateFormat);
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    printOrder() {
      const apiUrl =
        localStorage.getItem('apiUrl') || process.env.VUE_APP_API_URL;

      const token = localStorage.getItem('token');

      window.open(
        `${apiUrl}/reports/orders/${parseInt(this.$route.params.id, 10)}?access_token=${token}`,
        '_blank'
      );
    },
    checkIsNull(property) {
      if (property === 'article.vpc' && !this.article.vpc) {
        this.article.vpc = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.quantity' && !this.article.quantity) {
        this.article.quantity = 1;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.discount1' && !this.article.discount1) {
        this.article.discount1 = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.amount' && !this.article.amount) {
        this.article.amount = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (
        property === 'selectedArticle.vpc' &&
        !this.selectedArticle.vpc
      ) {
        this.selectedArticle.vpc = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (
        property === 'selectedArticle.quantity' &&
        !this.selectedArticle.quantity
      ) {
        this.selectedArticle.quantity = 1;
        this.changeTotalAmountOfEditArticle();
      } else if (
        property === 'selectedArticle.discount1' &&
        !this.selectedArticle.discount1
      ) {
        this.selectedArticle.discount1 = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (
        property === 'selectedArticle.amount' &&
        !this.selectedArticle.amount
      ) {
        this.selectedArticle.amount = 0;
        this.changeTotalAmountOfEditArticle();
      }
    },
    onArticleSelect(type, isVariation) {
      if (type === 'new' && !isVariation) {
        if (!this.article.vpc) {
          this.article.vpc = 0;
        } else {
          this.article.vpc = parseFloat(this.article.vpc); // parse, don't use toFixed (returns string)
        }
        if (!this.article.quantity) {
          this.article.quantity = 1;
        }
        if (!this.article.discount1) {
          if (this.article.matchedPP) {
            this.article.discount1 =
              (1 - this.article.price / this.article.vpc) * 100;
          } else {
            this.article.discount1 = 0;
        }
    }

    this.article.amount = parseFloat(
      (
        this.article.vpc -
        this.article.vpc * (this.article.discount1 / 100)
      ).toFixed(2),
      10
    );

    this.changeTotalAmountOfNewArticle(); // <-- this was missing!

  } else {
        this.article.code = this.variation.code;
        if (!this.variation.vpc) {
          this.article.vpc = 0;
        } else {
          this.article.vpc = this.variation.vpc.toFixed(2);
        }
        if (!this.article.quantity) {
          this.article.quantity = this.variation.quantity;
        }
        if (!this.article.discount1) {
          if (this.article.matchedPP) {
            this.article.discount1 =
              (1 - this.article.price / this.article.vpc) * 100;
          } else {
            this.article.discount1 = 0;
          }
        }

        this.article.amount = parseFloat(
          (
            this.article.vpc -
            this.article.vpc * (this.article.discount1 / 100)
          ).toFixed(2),
          10
        );

        this.changeTotalAmountOfNewArticle(isVariation);
      }
    },
    onNewQuantityChange() {
      const isVariation = !!this.variationId;
      this.changeTotalAmountOfNewArticle(isVariation);
    },
    onNewVPCChange() {
        let { vpc, discount1 } = this.article;
        vpc = vpc || 0;
        discount1 = discount1 || 0;
  
        this.article.amount = parseFloat(
          ((vpc || 0) - (vpc || 0) * ((discount1 || 0) / 100)).toFixed(2),
          10
        );

      this.changeTotalAmountOfNewArticle();
    },
    onNewDiscountChange() {
        let { vpc, discount1 } = this.article;
        vpc = vpc || 0;
        discount1 = discount1 || 0;
        this.article.amount = parseFloat(
          ((vpc || 0) - (vpc || 0) * ((discount1 || 0) / 100)).toFixed(2),
          10
        );

      this.changeTotalAmountOfNewArticle();
    },
    onNewAmountChange() {
        if (this.article.amount > this.article.vpc)
        this.article.amount = this.article.vpc;
      
      this.article.discount1 = (
        100 *
        (1 - this.article.amount / this.article.vpc)
      ).toFixed(2);

      this.changeTotalAmountOfNewArticle();
    },
    changeTotalAmountOfNewArticle() {
        let { quantity } = this.article;
        console.log(this.article);
        
        this.article.totalAmount = parseFloat(
          (this.article.amount * 1.17 * (quantity || 0)).toFixed(2),
          10
        );
        this.article.taxAmount = this.article.amount * 0.17 * (quantity || 0);

        this.article.totalAmountWithoutVat =
          this.article.totalAmount - this.article.taxAmount;
    },
    closeModal() {
      this.articleId = null;
      this.variationId = null;
      $('#add-article').modal('hide');
    },
    addArticleToOrder() {
        const foundArticle = this.order.orderItems.find(
          ({ articleId, variationId }) => articleId === this.article.id && variationId === this.variationId
      );

      if (foundArticle) {
        this.$toast.error('Artikal je već dodan.');
        $('#add-article').modal('hide');

        // Remove selected article and reset state on add article modal
        this.articleId = null;
        return;
      }
      const payload = {
        orderId: this.order.id,
        articleId: this.article.id,
        quantity: parseFloat(this.article.quantity) || 1,
        vpc: parseFloat(this.article.vpc) || 0,
        vpcDiscount: parseFloat(this.article.amount) || 0,
        discount: parseFloat(this.article.discount1) || 0,
        variationId: this.variationId,
        taxAmount: parseFloat(this.article.taxAmount) || 0,
        totalAmount: parseFloat(this.article.totalAmount) || 0,
      };

      api.addOrderItem(payload).then(() => {
        $('#add-article').modal('hide');
        this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
      });
      // this.updateDocumentItems();
      // Remove selected article and reset state on add article modal
      this.articleId = null;
      this.variationId = null;
    },
    showConfirmationModal() {
      if (this.selected.length) $('#confirm-delete').modal('show');
    },
    deleteOrder() {
      api
        .deleteOrders([this.order.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          if (response.data.status === 0) {
            $('#delete-order-modal').modal('hide');
            this.$router.push({ name: 'Orders' });
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    exportOrder() {
      api
        .exportOrder(this.order.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          if (response.data.status === 0) {
            $('#export-order-modal').modal('hide');
            this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
            this.exportFile(response.data.data);
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    exportFile(data) {
      // Sample data you are receiving from the backend
      const fileData = {
        fileContents: data.fileContents,
        contentType: data.contentType,
        fileDownloadName: data.fileDownloadName,
      };
      
      // Decode the Base64-encoded file content
      const byteCharacters = atob(fileData.fileContents);

      // Convert the byte characters into an array of byte numbers
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Convert the array of byte numbers into a typed array (Uint8Array)
      const byteArray = new Uint8Array(byteNumbers);

      // Create a Blob from the byte array with the correct content type
      const blob = new Blob([byteArray], { type: fileData.contentType });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create an anchor element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = fileData.fileDownloadName;

      // Append the anchor to the document, trigger the download, and then remove the anchor
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Revoke the object URL after a short delay to release memory
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 100);

      // Optionally, if you want to handle tab or popup opening (but not necessary here)
      // const newTab = window.open(url, '_blank');
      // newTab.close();
    },
    splitOpenModal() {
      $('#split-modal').modal('show');
    },
    refreshStockAmount() {
      api
        .getStockAmountOfArticles(this.order.orderItems.map((x) => x.articleId))
        .then((response) => {
          if (response.data && response.data.data.length > 0) {
            var data = response.data.data;
            this.order.orderItems.forEach((x) => {
              var item = data.filter((a) => a.articleId == x.articleId);
              if (item.length > 0) {
                x.articleStockAmount = item[0].stockAmount;
              }
            });
          }
          this.$toast.info('Uspješno osvježeno stanje');
        });
    },
    formatMomentDate(date, dateFormat = 'DD.MM.yyyy, HH:mm') {
      const formattedDate = moment.utc(date).local().format(dateFormat);
      return formattedDate;
    },
    splitOrder() {
      api
        .createOrdersBySplittingOrder({
          orderId: this.order.id,
          items: this.order.orderItems
            .filter((x) => x.newQuantity && x.newQuantity > 0)
            .map((x) => ({
              id: x.id,
              quantity: x.newQuantity,
            })),
        })
        .then((response) => {
          this.$toast.info(response.data.info);

          if (response.data.isValid) {
            $('#split-modal').modal('hide');
            this.$router.push({ name: 'Orders' });
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    mapOrderStatus: helpers.mapOrderStatus,
    updateOrderStatus() {
      api
        .updateOrderStatus({
          orderId: this.order.id,
          status: this.order.status,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.backendOrderStatus = this.order.status;
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => {
          $('#modalPromijeniStatus').modal('hide');
        });
    },
    cancelSplittingOrder() {
      $('#split-modal').modal('hide');
    },
    cancelOrder() {
      api
        .updateOrderStatus({
          orderId: this.order.id,
          status: 3,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.order.status = 3;
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => {
          $('#modalOtkaziNarudzbu').modal('hide');
        });
    },
    addOrderState() {
      const payload = {
        state: this.orderState.state,
        orderId: this.order.id,
        displayToCustomer: this.orderState.displayToCustomer,
      };
      api
        .addOrderState(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getOrderStates', {
            orderId: parseInt(this.$route.params.id, 10),
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => {
          $('#modalStanjeNarudzbe').modal('hide');
          this.orderState.state = '';
        });
    },
    deleteOrderState() {
      api
        .deleteOrderState(this.selectedState)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        })
        .finally(() => {
          $('#delete-order-state-modal').modal('hide');
          this.selectedState = null;
          this.$store.dispatch('getOrderStates', {
            orderId: parseInt(this.$route.params.id, 10),
          });
        });
    },
    updateDeliveryType() {
      api
        .updateDeliveryType({
          orderId: this.order.id,
          deliveryType: this.order.deliveryType,
          expressPostId: this.order.expressPostId,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => {
          $('#modalPromijeniDostavu').modal('hide');
        });
    },
    sendToExpressPost() {
      api
        .sendOrderToPostExpress(this.order.id)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    showDeleteOrderItemModal(itemId) {
      this.selectedItem = itemId;
      $('#delete-order-item-modal').modal('show');
    },
    handleBlur: debounce(function blur() {
      this.searchInput = '';
      this.showSearchResults = false;
    }, 250),
    handleSearch: debounce(function search() {
      // Needs to enter minimun 3 characters to perform search
      if (this.searchInput.trim().length < 3) return;

      this.showSearchResults = true;
      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: false,
        page: 1,
        pageSize: 5,
        quickSearch: this.searchInput.trim(),
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
        customerId: this.order.company.id,
      });
    }, 300),
    deleteSelected() {
      api
        .deleteOrderItems(this.selected)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.selected = [];
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => {
          this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
          $('#delete-order-item-modal').modal('hide');
        });
    },
    showUpdateQuantityModal(orderItemId, quantity) {
      this.selectedOrderItem = {
        orderItemId,
        quantity,
      };
      $('#update-order-item-quantity-modal').modal('show');
    },
    saveOrderItemsQuantity() {
      const orderItems = this.order.orderItems
        .filter((x) => x.quantity !== x.originalQuantity)
        .map((x) => {
          return { id: x.id, quantity: x.quantity };
        });
      api
        .updateOrderItemsQuantity(orderItems)
        .then((response) => {
          this.$toast.info(response.data.info);
          $('#update-order-item-quantity-modal').modal('hide');
          this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
          $('#update-order-item-quantity-modal').modal('hide');
        });
    },
    saveOrderDescription() {
       api
        .updateOrderDescription(this.$route.params.id, this.order.note)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    saveOrderCompany() {
      api.updateOrderCompany({
        orderId: this.$route.params.id,
        companyId: this.order.companyId,
      }).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    loadCompanies({ callback, searchQuery }) {
      this.$store
        .dispatch('getCompanies', {
          isSortAscending: true,
          retrieveAll: true,
          quickSearch: searchQuery,
          sortBy: 'title',
        })
        .then(() => {
          callback(null, this.companies);
        });
    },
  },
  async mounted() {
    const order = await this.$store.dispatch('getOrder', parseInt(this.$route.params.id, 10));
    this.backendOrderStatus = order.status;
    this.$store.dispatch('getMeasurementUnits', this.searchConfig);
    this.$store.dispatch('getOrderStates', {
      orderId: parseInt(this.$route.params.id, 10),
    });
    this.$store.dispatch('getExpressPosts', {
      retrieveAll: true,
    });
    this.$store.dispatch('getMasterCompanies');
  },
};
</script>

<style lang="scss" scoped>
.product-img-thumb {
  width: 70px;
  height: auto;
}

.select-padding {
  padding: 0;
}

.form-group + .form-group {
  border-top: none;
}

.form-control[readonly] {
  background-color: #fff;
}

.billing-shipping tr td:first-child {
  width: 30%;
}

.title-icon {
  display: flex;
  align-items: center;
  gap: 5px;
}
.title-icon i {
  color: #212529;
  font-size: 16px;
}

.mr-2 {
  margin-right: 3px;
}

.stock-amount {
  background-color: #ffbbbb !important;
  box-shadow: none;
}

.overstock-amount {
  background-color: #e0b38a !important;
  box-shadow: none;
}
</style>
<style lang="scss">
#add-article,
#edit-article {
  .modal-md-2.modal-dialog {
    min-width: 620px;

    .card-body {
      padding: 0 0.5em;
      box-shadow: none;
    }
  }

  // Ostatak stila za ove ID-ove
  .header-center {
    position: relative;
  }

  .article-list {
    position: absolute;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    list-style: none;
    padding: 0;
    z-index: 1020;
    left: 0;
    top: 40px;
    width: 100%;
    background: #fff;
    max-height: 450px;
    overflow-y: auto;

    li {
      display: block;
      border-top: 1px solid #ced4da;
      padding: 5px;
      cursor: pointer;
      overflow: hidden;
      opacity: 0.75;

      &:first-child {
        border-top: none;
      }

      &:hover {
        opacity: 1;
        .article-title {
          color: #259ddf;
          text-decoration: underline;
        }
      }
    }
  }

  .article-wrapper {
    display: flex;
    flex-basis: 50%;
  }

  .article-description {
    display: flex;
    flex-direction: column;
    height: 80px;
    color: #777;
  }

  .article-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-right: 5px;
  }

  .product-image {
    display: block;
    width: 70px;
    height: 70px;
  }

  .product-image-container {
    margin-right: 5px;
  }

  .article-title,
  .article-code,
  .article-price {
    width: 100%;
    font-size: 16px;
    flex-basis: 50%;
  }

  .article-variation-description {
    width: 100%;
    font-size: 13px;
    font-style: italic;
    color: #999;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #export-order-modal .modal-dialog .modal-content {
    min-width: 1000px;
  }
}
</style>
